import { SUPPORTED_LOCALES, useI18n, type Locale } from './index';

/**
 * Pill-style language switcher matching the fan SPA's indigo accent.
 * Compact enough to live in a corner of auth pages or in a settings
 * menu later.
 */
export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <div
      role="group"
      aria-label={t('language.label')}
      className={`inline-flex items-center gap-1 rounded-full border border-slate-800 bg-slate-900/60 p-1 ${className}`}
    >
      {SUPPORTED_LOCALES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLocale(l.code as Locale)}
          aria-pressed={locale === l.code}
          className={`rounded-full px-3 py-1 text-[11px] font-medium tracking-wide transition ${
            locale === l.code
              ? 'bg-violet-500/15 text-violet-300 ring-1 ring-inset ring-violet-500/30'
              : 'text-slate-400 hover:bg-slate-800/60 hover:text-slate-200'
          }`}
        >
          {t(l.labelKey)}
        </button>
      ))}
    </div>
  );
}
